import { render, staticRenderFns } from "./test-headset.vue?vue&type=template&id=7da5423c&"
import script from "./test-headset.vue?vue&type=script&lang=js&"
export * from "./test-headset.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports